import React from 'react';
import classNames from 'classnames';
// TO DO : Replace with Crown UI HelperText when available
import { HelperText } from '@hallmark/web.core.forms.helper-text';
import { Label, FieldTypes } from '@hallmark/web.core.forms.label';
import { RadioCardProps } from './radio-card-types';
import styles from './radio-card.module.scss';
import { RadioButton } from '@dotcom/crown-ui';

export const RadioCard = ({
  addClass = '',
  children,
  domId,
  helperText = '',
  isDisabled,
  register,
  required,
  testId,
  value,
}: RadioCardProps): React.ReactElement => {
  const containerClasses = classNames(
    styles['input-field-container'],
    styles['input-field-card'],
    isDisabled ? styles['input-field-disabled'] : '',
    addClass,
  );

  const labelContainerClasses = classNames(styles['field-label']);

  return (
    <div className={containerClasses} data-testid={testId}>
      <RadioButton className={styles.indicator} domId={domId} register={register} value={value} />
      <Label addClass={labelContainerClasses} fieldType={FieldTypes.Radio} htmlFor={domId} required={required}>
        {helperText && <HelperText addClass={styles['helper-text']}>{helperText}</HelperText>}
        {children}
      </Label>
    </div>
  );
};

export default RadioCard;
